import { useCallback, useState } from 'react';
import {
  createKeyForListPurgeJobFileObjects,
  useQueryToListPurgeJobFileObjects
} from '@/hooks/queries/useQueryToListPurgeJobFileObjects';
import { useQueryClient } from 'react-query';

const usePurgeJobFileObjectList = ({ spaceId, projectId, jobId }) => {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [statuses, setStatuses] = useState([]);

  const queryClient = useQueryClient();
  const { data: dataToListPurgeJobFileObjects, isLoading: isLoadingToListPurgeJobFileObjects } =
    useQueryToListPurgeJobFileObjects(
      { spaceId: spaceId, projectId: projectId, jobId: jobId },
      page - 1,
      pageSize,
      statuses
    );

  const refresh = useCallback(async () => {
    await queryClient.invalidateQueries([
      createKeyForListPurgeJobFileObjects(
        {
          spaceId: spaceId,
          projectId: projectId,
          jobId: jobId
        },
        page,
        pageSize,
        statuses
      )[0]
    ]);
  }, [spaceId, jobId]);

  return {
    isLoading: isLoadingToListPurgeJobFileObjects,
    totalCount: dataToListPurgeJobFileObjects?.totalCount ?? 0,
    fileObjects: dataToListPurgeJobFileObjects?.results ?? [],
    page,
    pageSize,
    setPage,
    setPageSize,
    statuses,
    setStatuses,
    refresh
  };
};

export default usePurgeJobFileObjectList;
